import { jsx as m, jsxs as a } from "react/jsx-runtime";
import { useMemo as p, Fragment as o } from "react";
import { twMerge as u } from "tailwind-merge";
import { StoreItemEnum as v } from "../../enums/store-item-enum.mjs";
import A, { LAYOUT_BASE_CLASSNAME as t } from "../../components/layout.mjs";
import L from "../../components/affiliate-badge.mjs";
import { Profile as g } from "../../profile/index.mjs";
import { getCommonItem as s } from "../../utils/get-item.mjs";
const B = ({
  profile: d,
  socialLinks: h,
  items: n,
  affiliateLink: l,
  displayAffiliateLink: c
}) => {
  const f = p(() => {
    const i = [];
    let e;
    return n.forEach((r) => {
      r.type === v.header ? (e && i.push(e), e = { header: r, items: [] }) : e ? e.items.push(r) : e = { header: null, items: [r] };
    }), e && i.push(e), i;
  }, [n]);
  return /* @__PURE__ */ m(A, { children: /* @__PURE__ */ a("div", { className: u(t, "relative mb-5 sm:mt-5"), children: [
    /* @__PURE__ */ m(g, { profile: d, socialLinks: h }),
    /* @__PURE__ */ m("div", { className: t, children: f.map((i, e) => i.header ? /* @__PURE__ */ a("section", { className: t, children: [
      s(i.header),
      i.items.map((r) => /* @__PURE__ */ m(o, { children: s(r, { headingLevel: "h3" }) }, r.id))
    ] }, i.header.id) : /* @__PURE__ */ m(o, { children: i.items.map((r) => /* @__PURE__ */ m(o, { children: s(r, { headingLevel: "h2" }) }, r.id)) }, `no-section-${e}`)) }),
    c && /* @__PURE__ */ m(L, { affiliateLink: l })
  ] }) });
};
export {
  B as Home
};
